import React from 'react'
import { StyledQuestionnaireFormLabel, QuestionnaireFormLabelProps } from './styled'

// ATTENTION!
// このコンポーネントはカルテ（登録直後のカルテ、プロフィールシート内のカルテ）でのみ使用されます。
// 新しいコンポーネントでラベルコンポーネントを使用する場合は、Labelコンポーネントを使用してください。
export const QuestionnaireFormLabel: React.FC<QuestionnaireFormLabelProps> = (props: QuestionnaireFormLabelProps) => {
  return <StyledQuestionnaireFormLabel {...props} />
}
